import React from 'react';
import CarpenterIcon from "@mui/icons-material/Carpenter";
import {Box, Typography} from "@mui/material";

const Logo = () => {
    return (
        <Box display='flex'>
            <CarpenterIcon sx={{display: {xs: 'none', md: 'flex'}, mr: 2}}/>
            <Typography
                variant="h6"
                noWrap
                component="a"
                href="/"
                draggable={false}
                sx={{
                    mr: 2,
                    display: {xs: 'none', md: 'flex'},
                    fontFamily: 'Roboto Mono',
                    fontWeight: 600,
                    letterSpacing: '.1rem',
                    color: 'inherit',
                    textDecoration: 'none',
                    fontSize: '1.1em',
                }}>Keiblinger</Typography>
        </Box>
    );
};

export default Logo;